import { BB_NAVIGATE } from '../constants/webViewNavigate'
import { postHostPayload, pushRoute } from './reactNativeWebView'

/** The mobile app (RN WebView / iframe on RN web) opens the panel with `?mobile=1`. */
export function isMobileAppSearch(): boolean {
  return window.location.search.includes('mobile=1')
}

/**
 * Ask RN/iframe host to open the module at `path` (see useWebViewNavigateMessage).
 * Callers send it only inside the mobile app; app versions before 6.4.5 ignore it.
 *
 * @returns `true` when the message was sent — the caller must not navigate itself.
 */
export function postWebViewNavigateMessage(path: string): boolean {
  return postHostPayload({ path, type: BB_NAVIGATE })
}

/**
 * Opens another module (e.g. `/price/set`): in the app via the RN host, otherwise
 * with the router — `path` outside the app, `mobileUrl` when the app has no host bridge.
 * Returns true when the host accepted the message.
 */
export function navigateOrNotifyHost(
  path: string,
  {
    mobile = isMobileAppSearch(),
    mobileUrl = `${path}?mobile=1`,
  }: { mobile?: boolean; mobileUrl?: string } = {},
): boolean {
  if (mobile && postWebViewNavigateMessage(path)) {
    return true
  }

  pushRoute(mobile ? mobileUrl : path)
  return false
}
